<script lang="ts" setup>
import { NavRail, NavRailItem } from '@forgd/ui-kit/blocks/nav'
import { withTrailingSlash } from 'ufo'
import type { AppNavLink } from '../utils/nav'
import { navMenu } from '../utils/nav'

defineOptions({
  inheritAttrs: false,
})

const expanded = useState('nav:expanded', () => false)
const route = useRoute()
const NuxtLink = resolveComponent('NuxtLink')

function isCurrent(item: AppNavLink, strict: boolean = false) {
  const { to, shouldHighlight } = item
  const pathSegments = (to || '').split('/').filter(Boolean)
  const currPathSegments = (route.path || '').split('/').filter(Boolean)
  if (!strict) {
    if (withTrailingSlash(currPathSegments[0]) === withTrailingSlash(pathSegments[0])) {
      return true
    }

    if (shouldHighlight && shouldHighlight(route.path)) {
      return true
    }
  }
  if (route.path.startsWith('/academy')) {
    const categoryPath = currPathSegments.slice(0, 3).join('/')
    return withTrailingSlash(categoryPath) === withTrailingSlash(pathSegments.slice(0, 3).join('/'))
  }
  if (!to) {
    return false
  }
  return withTrailingSlash(to) === withTrailingSlash(route.path)
}

function itemAs(item: AppNavLink) {
  if (!item.to) {
    return 'button'
  }
  return item.external ? 'a' : NuxtLink
}

function itemLinkProps(item: AppNavLink) {
  const extra = { 'data-testid': item.testId }
  if (!item.to) {
    return extra
  }
  if (item.external) {
    return { href: item.to, target: '_blank', rel: 'noopener noreferrer', ...extra }
  }
  return { to: item.to, ...extra }
}
</script>

<template>
  <NavRail class="hidden md:block" :expanded="expanded" :expanded-width="260" aria-label="Liquidity Navigation" v-bind="$attrs">
    <template #logo>
      <NuxtLink to="/" aria-label="Forgd Liquidity home" class="[&_img]:w-[140px]">
        <CoreLogo :collapsed="!expanded" />
      </NuxtLink>
    </template>

    <div class="flex flex-col gap-1 px-4 py-2" :class="expanded ? '' : 'items-center'">
      <NavRailItem
        v-for="item in navMenu[0]"
        :key="item.label"
        :as="itemAs(item)"
        :label="item.label ?? ''"
        :expanded="expanded"
        :active="isCurrent(item, item.isStrict)"
        v-bind="itemLinkProps(item)"
        v-on="item.on ?? {}"
      >
        <template #icon>
          <component :is="item.icon" class="size-5 shrink-0" />
        </template>
      </NavRailItem>
    </div>

    <template #footer>
      <div class="flex flex-col gap-1 px-4 py-2" :class="expanded ? '' : 'items-center'">
        <NavRailItem
          v-for="item in navMenu[1]"
          :key="item.label"
          :as="itemAs(item)"
          :label="item.label ?? ''"
          :expanded="expanded"
          :active="isCurrent(item, item.isStrict)"
          v-bind="itemLinkProps(item)"
          v-on="item.on ?? {}"
        >
          <template #icon>
            <component :is="item.icon" class="size-5 shrink-0" />
          </template>
        </NavRailItem>
      </div>
    </template>
  </NavRail>
</template>
